import React from 'react'
import Banner from '../components/Banner'
import CoinsTable from '../components/CoinsTable'
function Homepage() {
  return (
   <>
   <Banner/>
   <CoinsTable/>
   </>
  )
}

export default Homepage
